import { useState, useEffect, useRef } from "react";
import "./CountrySelect.css";

const CountrySelect = ({ setSelectedCountry, selectedCountry }) => {
    const [countries, setCountries] = useState([]);
    const [filteredCountries, setFilteredCountries] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const wrapperRef = useRef(null);

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await fetch('/countries.json');
                const data = await response.json();
                const countryNames = data
                    .map(country => country.translations?.rus?.common)
                    .filter(Boolean)
                    .sort();
                setCountries(countryNames);
                setFilteredCountries(countryNames);

                if (selectedCountry && countryNames.includes(selectedCountry)) {
                    setSearchTerm(selectedCountry);
                } else if (countryNames.length > 0) {
                    setSearchTerm(countryNames[0]);
                    setSelectedCountry(countryNames[0]);
                }
            } catch (error) {
                console.error("Ошибка при загрузке стран:", error);
            }
        };

        fetchCountries();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setSelectedCountry(value);

        setFilteredCountries(
            countries.filter(country =>
                country.toLowerCase().includes(value.toLowerCase())
            )
        );
        setShowDropdown(true);
    };

    const handleSelectCountry = (country) => {
        setSelectedCountry(country);
        setSearchTerm(country);
        setShowDropdown(false);
    };

    return (
        <div className="country-select" ref={wrapperRef}>
            <label htmlFor="country-input">Выберите страну:</label>
            <div className="input-wrapper">
                <input
                    type="text"
                    id="country-input"
                    className="country-input"
                    value={searchTerm}
                    onChange={handleInputChange}
                    onFocus={() => setShowDropdown(true)}
                    placeholder="Выберите страну"
                />
                <span className="dropdown-arrow">&#9662;</span>
            </div>
            {showDropdown && filteredCountries.length > 0 && (
                <ul className="dropdown-list">
                    {filteredCountries.map((country, index) => (
                        <li
                            key={index}
                            onClick={() => handleSelectCountry(country)}
                            className={selectedCountry === country ? "selected" : ""}
                        >
                            {country}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CountrySelect;
